import React from 'react';
import { OverviewChrome } from '../boardStates';
import { PortalStatus, pillClassToVariant } from '../ui';

export function StatusPill({ chrome }: { chrome: OverviewChrome }) {
  return <PortalStatus id="ov-pill" dot variant={pillClassToVariant(chrome.pill)} label={chrome.text} />;
}
